import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-markdown",
  "use": "icon-markdown-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-markdown\"><path d=\"M219.429 146.286v731.429c0 40 32 72 72 72h441.142c40 0 72-32 72-72V146.286c0-40-32-72-72-72H291.429c-40 0-72 32-72 72z\" fill=\"#2196F3\" p-id=\"10426\" /><path d=\"M365.714 292.571h73.143v146.286H365.714zM512 292.571h146.286v73.143H512zM512 438.857h146.286v73.143H512zM365.714 512h73.143v146.286H365.714zM512 585.143h146.286v73.143H512z\" fill=\"#FFFFFF\" p-id=\"10427\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol